import { ActionStyles } from "../../../enums/ActionStyles"
import { ActionTypes } from "../../../enums/ActionTypes"
import { ISchemaAction } from "../entityComponents/Schema"
import iconCross from "../../../assets/icons/icon-cross.svg"
import { Button } from "react-aria-components"
import { modalSignal } from "../Modal/ModalContainer"
import { ISelected } from "./List"
import MoveModal from "../Modal/MoveModal"
import ReturnPackingBoxesModal from "../Modal/ReturnPackingBoxesModal"
import { usePermissions } from "../../../modules/auth/Permissions/PermissionContext"

interface IListActions {
    selected: ISelected[]
    clearFunc: Function
    actions: ISchemaAction[]
}

export default function ListActions({ selected, clearFunc, actions }: IListActions) {
    const permissionsContext = usePermissions();

    return (
        <div className="list-actions__wrapper">
            <div className="display--flex alignItems--center">
                <p className="small">{selected.length} Items selected</p>
                <Button className={"button button--text-only button--with-icon"} onPress={() => clearFunc()}>
                    <img src={iconCross} />
                    <p className="button-text">Clear</p>
                </Button>
            </div>
            <div className="display--flex alignItems--center gap--xxs">
                {actions
                    .filter(action => action.permissionToView === undefined || action.permissionToView(permissionsContext))
                    .map((x, i) => (
                        <Button key={i} className={GetButtonClass(x.style)} isDisabled={x.isEnabled ? !x.isEnabled(selected) : !OnlyOneEntityName()} onPress={GetButtonFunction(x.action)}>
                            <img src={x.icon} />
                            <p className="button-text">{x.text}</p>
                        </Button>
                    ))}
            </div>
        </div>
    )

    function OnlyOneEntityName() {
        const firstVal = selected[0].entityName
        return selected.every(x => x.entityName == firstVal)
    }

    function GetButtonClass(style: string) {

        switch (style) {
            case ActionStyles.primary:
                return "button button--small button--primary button--with-icon"
            case ActionStyles.secondary:
                return "button button--small button--secondary button--with-icon"
        }
    }

    function GetButtonFunction(action: string) {
        switch (action) {
            default:
                return () => { }
            case ActionTypes.move:
                return () => {
                    modalSignal.value = <MoveModal entitiesToMove={selected} entityName={selected[0].entityName} />
                }
            case ActionTypes.returnPackingBoxes:
                return () => {
                    modalSignal.value = <ReturnPackingBoxesModal entitiesToReturn={selected.map(x => x.id)} />
                }
        }
    }
}